var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-drawer",
    {
      ref: "comment-drawer",
      staticClass: "comment-drawer",
      attrs: {
        title: "",
        direction: "btt",
        size: "70%",
        "show-close": false,
        visible: _vm.drawer,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawer = $event
        },
        opened: _vm.opened,
      },
    },
    [
      _c("div", { staticClass: "row" }, [
        !_vm.commentsDisabled
          ? _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("q-editor", {
                  ref: "editorRef",
                  attrs: {
                    placeholder: "댓글을 작성해주세요.",
                    "max-height": "400px",
                    "content-class": "bg-amber-3",
                    "toolbar-text-color": "white",
                    "toolbar-toggle-color": "yellow-8",
                    "toolbar-bg": "primary",
                    toolbar: [
                      ["bold", "italic", "underline"],
                      ["image"],
                      ["save", "close"],
                    ],
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "image",
                        fn: function () {
                          return [
                            !_vm.commentsDisabled
                              ? _c(
                                  "q-btn",
                                  {
                                    attrs: {
                                      flat: "",
                                      round: "",
                                      size: "9px",
                                      color: "white",
                                      icon: "photo",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.insertImg("I")
                                      },
                                    },
                                  },
                                  [_c("q-tooltip", [_vm._v(" 이미지 넣기 ")])],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "save",
                        fn: function () {
                          return [
                            !_vm.commentsDisabled
                              ? _c(
                                  "q-btn",
                                  {
                                    attrs: {
                                      flat: "",
                                      round: "",
                                      size: "9px",
                                      color: "white",
                                      icon: "post_add",
                                      label: "댓글 게시",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.saveComments()
                                      },
                                    },
                                  },
                                  [_c("q-tooltip", [_vm._v(" 댓글 게시 ")])],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "close",
                        fn: function () {
                          return [
                            _c(
                              "q-btn",
                              {
                                attrs: {
                                  flat: "",
                                  round: "",
                                  size: "9px",
                                  color: "white",
                                  icon: "close",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.closeComments()
                                  },
                                },
                              },
                              [_c("q-tooltip", [_vm._v(" 댓글창 닫기 ")])],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    633509798
                  ),
                  model: {
                    value: _vm.editorComment,
                    callback: function ($$v) {
                      _vm.editorComment = $$v
                    },
                    expression: "editorComment",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _vm.comments && _vm.comments.length > 0
              ? _c(
                  "q-list",
                  { ref: "comments-list", staticClass: "comments-list" },
                  [
                    _c("q-virtual-scroll", {
                      staticStyle: { "max-height": "400px" },
                      attrs: { items: _vm.comments, separator: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ item, index }) {
                              return [
                                _c(
                                  "q-item",
                                  { key: index, attrs: { dense: "" } },
                                  [
                                    _c(
                                      "q-item-section",
                                      [
                                        _c(
                                          "q-item-label",
                                          [
                                            _c(
                                              "q-chip",
                                              {
                                                attrs: {
                                                  color: "teal",
                                                  "text-color": "white",
                                                  icon: "face",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.regUserName) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "q-item-label",
                                          {
                                            staticClass: "comments-area",
                                            attrs: { caption: "" },
                                          },
                                          [
                                            !item.edit
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      item.comments
                                                    ),
                                                  },
                                                })
                                              : _c("q-editor", {
                                                  attrs: {
                                                    "max-height": "250px",
                                                    "content-class":
                                                      "bg-amber-3",
                                                    "toolbar-text-color":
                                                      "white",
                                                    "toolbar-toggle-color":
                                                      "yellow-8",
                                                    "toolbar-bg": "primary",
                                                    toolbar: [
                                                      [
                                                        "bold",
                                                        "italic",
                                                        "underline",
                                                      ],
                                                      ["image"],
                                                      ["save"],
                                                    ],
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "image",
                                                        fn: function () {
                                                          return [
                                                            _c(
                                                              "q-btn",
                                                              {
                                                                attrs: {
                                                                  flat: "",
                                                                  round: "",
                                                                  size: "9px",
                                                                  color:
                                                                    "white",
                                                                  icon: "photo",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.insertImg(
                                                                        "U",
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "q-tooltip",
                                                                  [
                                                                    _vm._v(
                                                                      " 이미지 넣기 "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                      {
                                                        key: "save",
                                                        fn: function () {
                                                          return [
                                                            !_vm.commentsDisabled
                                                              ? _c("q-btn", {
                                                                  attrs: {
                                                                    flat: "",
                                                                    round: "",
                                                                    size: "9px",
                                                                    color:
                                                                      "white",
                                                                    icon: "upload_file",
                                                                    label:
                                                                      "댓글 수정",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.saveComments(
                                                                          item.sysCommentsId,
                                                                          item.comments
                                                                        )
                                                                      },
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: item.comments,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "comments",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.comments",
                                                  },
                                                }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "q-item-section",
                                      { attrs: { side: "", top: "" } },
                                      [
                                        _c(
                                          "q-item-label",
                                          { attrs: { caption: "" } },
                                          [_vm._v(_vm._s(item.regDtStr))]
                                        ),
                                        _c(
                                          "div",
                                          { staticStyle: { height: "40px" } },
                                          [
                                            item.regFlag &&
                                            !_vm.commentsDisabled
                                              ? _c(
                                                  "q-btn",
                                                  {
                                                    attrs: {
                                                      flat: "",
                                                      round: "",
                                                      size: "15px",
                                                      icon: "delete",
                                                      color: "negative",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteComments(
                                                          item.sysCommentsId
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("q-tooltip", [
                                                      _vm._v(" 댓글 지우기 "),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            item.regFlag &&
                                            !_vm.commentsDisabled &&
                                            !item.edit
                                              ? _c(
                                                  "q-btn",
                                                  {
                                                    attrs: {
                                                      flat: "",
                                                      round: "",
                                                      size: "15px",
                                                      icon: "edit",
                                                      color: "blue",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.editComments(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("q-tooltip", [
                                                      _vm._v(" 댓글 수정하기 "),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            item.regFlag &&
                                            !_vm.commentsDisabled &&
                                            item.edit
                                              ? _c(
                                                  "q-btn",
                                                  {
                                                    attrs: {
                                                      flat: "",
                                                      round: "",
                                                      size: "15px",
                                                      icon: "refresh",
                                                      color: "grey",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.cancelComments(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("q-tooltip", [
                                                      _vm._v(" 댓글 수정취소 "),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1544555538
                      ),
                    }),
                  ],
                  1
                )
              : _c(
                  "q-list",
                  { attrs: { bordered: "", padding: "" } },
                  [
                    _c(
                      "q-item",
                      [
                        _c(
                          "q-item-section",
                          [
                            _c(
                              "q-item-label",
                              {
                                staticClass: "non-comments",
                                attrs: { overline: "" },
                              },
                              [_vm._v("❌ 등록된 댓글이 없습니다. ❌")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }